import {
    GOOGLE_METADATA_BY_KEY,
    INSTAGRAM_METADATA_BY_KEY,
    POPULARITY_METADATA_BY_KEY,
    TIKTOK_METADATA_BY_KEY,
} from 'utils/metrics';
import {
    useCurrentCountry,
    useInstagramWeeks,
    useTikTokWeeks,
} from 'utils/hooks';
import { BodySemi } from 'components/Text';
import { DefinitionTooltipContent } from 'components/DefinitionTooltip';
import { SoftButtonLink } from 'components/Button';
import Stack from 'components/Stack';
import styled from 'styled-components';

const FauxTooltips = styled(Stack)`
    max-width: 40rem;
`;

const FauxTooltip = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
    gap: 1rem;
    & > * {
        color: black;
    }
`;

function Tooltips() {
    const weeksQueryTikTok = useTikTokWeeks();
    const weeksQueryInstagram = useInstagramWeeks();
    return (
        <div>
            <BodySemi as="h2">Data Sources</BodySemi>
            <nav>
                <ul>
                    <li>
                        <SoftButtonLink to="/admin/tooltips#google">
                            Google
                        </SoftButtonLink>
                    </li>
                    <li>
                        <SoftButtonLink to="/admin/tooltips#tiktok">
                            TikTok
                        </SoftButtonLink>
                    </li>
                    <li>
                        <SoftButtonLink to="/admin/tooltips#instagram">
                            Instagram
                        </SoftButtonLink>
                    </li>
                    <li>
                        <SoftButtonLink to="/admin/tooltips#pop-index">
                            Popularity Index
                        </SoftButtonLink>
                    </li>
                </ul>
            </nav>
            {[
                {
                    key: 'google',
                    title: 'Google',
                    metadata: GOOGLE_METADATA_BY_KEY,
                },
                {
                    key: 'tiktok',
                    title: 'TikTok',
                    metadata: TIKTOK_METADATA_BY_KEY,
                },
                {
                    key: 'instagram',
                    title: 'Instagram',
                    metadata: INSTAGRAM_METADATA_BY_KEY,
                },
                {
                    key: 'pop-index',
                    title: 'Popularity Index',
                    metadata: POPULARITY_METADATA_BY_KEY,
                },
            ].map(({ key, title, metadata }) => {
                const { year, week } =
                    key === 'tiktok'
                        ? weeksQueryTikTok
                        : key === 'instagram'
                          ? weeksQueryInstagram
                          : { year: null, week: null };
                return (
                    <section key={key}>
                        <BodySemi
                            as="h3"
                            id={key}
                            css="font-size: 1.5rem; font-weight: 700; text-transform: none;"
                        >
                            {title}
                        </BodySemi>
                        <FauxTooltips $space="1.5rem">
                            {Object.entries(metadata).map(
                                ([metricKey, value]) => {
                                    const tooltip =
                                        value.getTableColumnConfig()?.tooltip;
                                    if (!tooltip) return null;
                                    return (
                                        <FauxTooltip
                                            key={`${key}-${metricKey}`}
                                        >
                                            <DefinitionTooltipContent
                                                {...tooltip}
                                                title={
                                                    <>
                                                        {tooltip.title}{' '}
                                                        <pre
                                                            css={`
                                                                display: inline-block;
                                                                background: ${({
                                                                    theme,
                                                                }) =>
                                                                    theme.gray_200};
                                                                font-size: 0.875rem;
                                                                font-weight: normal;
                                                                text-transform: none;
                                                                padding: 0 1ch;
                                                            `}
                                                        >
                                                            {value?.key}
                                                        </pre>
                                                    </>
                                                }
                                                week={week}
                                                year={year}
                                            />
                                        </FauxTooltip>
                                    );
                                },
                            )}
                        </FauxTooltips>
                    </section>
                );
            })}
        </div>
    );
}

export default Tooltips;
